export default __webpack_public_path__ + "static/lounge-area-comum-66d2653ac21a2a00ca1c8b0387198288.webp";